import React from "react";
import { Grid } from "@mui/material";

import { NotFoundItemView, CircularLoader } from "..";
import { useAppSelector, selectInstrument } from "@redux";
import { useInfiniteScroll } from "@utils";
import { StyledInstrumentsListItemComponent, InstrumentItemComponent } from ".";
interface IProps {
  loading: boolean;
  products: any;
  categoryId?: any;
}
export const InstrumentsListItemComponent = (props: IProps) => {
  const { loading, products, categoryId } = props;

  const { visibleItems, hasMore, isLoadingMore, sentinelRef } =
    useInfiniteScroll<any>(products ?? [], { pageSize: 15 });

  // redux store
  const instrument = useAppSelector(selectInstrument);
  const { dataResult } = instrument;
  return (
    <StyledInstrumentsListItemComponent>
      {dataResult?.category && (
        <div className="Instruments__title">
          {dataResult?.category} : {dataResult?.subCategory}{" "}
        </div>
      )}
      {loading ? (
        <div className="wrapperLoading">
          <CircularLoader loading={loading} type="fullContent" />
        </div>
      ) : products?.length ? (
        <>
          <div className="Instruments__content">
            <Grid container spacing={2}>
              {visibleItems.map((item) => (
                <Grid key={item.id} item xs={12} sm={12} md={12}>
                  <InstrumentItemComponent categoryId={categoryId} item={item} />
                </Grid>
              ))}
            </Grid>
          </div>
          {hasMore && <div ref={sentinelRef} />}
          {isLoadingMore && (
            <div className="wrapperLoading">
              <CircularLoader loading type="fullContent" />
            </div>
          )}
        </>
      ) : (
        <div className="error">
          <NotFoundItemView />
        </div>
      )}
    </StyledInstrumentsListItemComponent>
  );
};
